import React, { useEffect } from 'react';

import { DATA_TABLE_SOURCE_SUNSETUP_DRIVER_ORDERS } from 'common/dataTableConstants';

import {
  JOB_ORDER_STATUS_CREATED,
  JOB_ORDER_STATUS_ASSIGNED,
  JOB_ORDER_STATUS_ACCEPTED,
} from 'common/jobConstants';

import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrSunSetupDriverOrderItem from 'client/components/SrSunSetupDriverOrders/SrSunSetupDriverOrderItem';

function getDataTableSettingsFromProps({ driverId }) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_SUNSETUP_DRIVER_ORDERS,
    rootViewId: DATA_TABLE_SOURCE_SUNSETUP_DRIVER_ORDERS,
    initialViewSettings: {
      filter: {
        'jobOrders.driverId': driverId,
        'jobOrders.status': [
          JOB_ORDER_STATUS_CREATED,
          JOB_ORDER_STATUS_ASSIGNED,
          JOB_ORDER_STATUS_ACCEPTED,
        ],
      },
      sort: {
        'jobOrders.dueDate': 'asc',
      },
      loadAllData: true,
    },
    itemsPropName: 'jobOrders',
  };

  return dataTableSettings;
}

const SrSunSetupDriverOrders = ({ driverId }) => {
  let _reloadItems;

  useEffect(() => {
    const interval = global.setInterval(() => {
      if (_reloadItems) {
        _reloadItems({
          count: 9999,
          filter: {
            'jobOrders.driverId': driverId,
            'jobOrders.status': [
              JOB_ORDER_STATUS_CREATED,
              JOB_ORDER_STATUS_ASSIGNED,
              JOB_ORDER_STATUS_ACCEPTED,
            ],
          },
        });
      }
    }, 2000);
    return () => {
      global.clearInterval(interval);
    };
  });

  return (
    <SrDataTableConnected {...getDataTableSettingsFromProps({ driverId })}>
      {({ jobOrders, dataTableApiState, onInfiniteScrollWrapperRef, reloadItems }) => {
        _reloadItems = reloadItems;
        return (
          <>
            <div ref={onInfiniteScrollWrapperRef}>
              {(jobOrders || []).map((jobOrder) => {
                return (
                  <SrSunSetupDriverOrderItem
                    key={jobOrder.id}
                    jobOrder={jobOrder}
                    driverId={driverId}
                    reloadItems={reloadItems}
                  />
                );
              })}
              {!dataTableApiState.inProgress && jobOrders.length === 0 && (
                <SrFlex justify="center" margin="40px 0 0">
                  <SrText decoration="underline-yellow">
                    <strong>0</strong> orders found.
                  </SrText>
                </SrFlex>
              )}
              {dataTableApiState.inProgress && (
                <SrFlex justify="center">
                  <div className="loading-gif" />
                </SrFlex>
              )}
            </div>
          </>
        );
      }}
    </SrDataTableConnected>
  );
};

SrSunSetupDriverOrders.displayName = 'SrSunSetupDriverOrders';

export default SrSunSetupDriverOrders;
